<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-toolbar dense dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text my-auto">Calculation Results</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <strong>Terminal Id:</strong> {{ calculationMetaData.TerminalID ?? "N/A" }}
            </v-col>
            <v-col cols="12" md="8">
                <strong>Terminal Name:</strong> {{ calculationMetaData.TerminalName ?? "N/A" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <strong>Station Id:</strong> {{ calculationMetaData.StationID ?? "N/A" }}
            </v-col>
            <v-col cols="12" md="8">
                <strong>Station Name:</strong> {{ calculationMetaData.StationName ?? "N/A" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <strong>Shift Id:</strong> {{ calculationMetaData.ShiftDetail ?? "N/A" }}
            </v-col>
            <v-col cols="12" md="4">
                <strong>Day of the Week:</strong> {{ calculationMetaData.weekday ?? "N/A" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="({ key, value }, idx) in truckYard" cols="12" md="4">
                <strong>{{ key }}:</strong> {{ value }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-simple-table>
                    <thead>
                        <tr>
                            <th>Event</th>
                            <th>Zone Origin Id</th>
                            <th>Zone Destination Id</th>
                            <th>Duration (in mins)</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in calculationData" :key="'event-' + idx">
                            <td class="text-left">{{ item.event }}</td>
                            <td class="text-left">{{ item.zoneOriginId }}</td>
                            <td class="text-left">{{ item.zoneDestinationId }}</td>
                            <td class="text-left">{{ item.duration }}</td>
                        </tr>
                        <tr></tr>
                        <tr :class="{ 'highlight-row': true }">
                            <td class="text-left">Sum of Delivery Route Durations</td>
                            <td></td>
                            <td></td>
                            <td class="text-left">{{ totalDuration }} ({{ Number(totalDuration / 60).toFixed(2) }} hrs)
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: {
        calculationData: {
            type: Array,
            required: true
        },
        calculationMetaData: {
            type: Object,
            required: true
        }
    },
    computed: {
        totalDuration() {
            const totalMinutes = this.calculationData.reduce((sum, item) => {
                return sum + (isNaN(item.duration) ? 0 : Number(item.duration));
            }, 0);
            return totalMinutes.toFixed(2);
        },

        truckYard() {
            if (this.calculationMetaData.extra_info) {
                return Object.entries(this.calculationMetaData.extra_info).map(([key, value]) => ({ key, value }));
            }
            return [];
        }
    },
    data() {
        return {};
    }
}
</script>

<style scoped>
.highlight-row {
    background-color: #f5f5f5;
    font-weight: bold;
}
</style>